import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiUrlConstants } from "../../common/constants/api.constants";
import { Observable } from "rxjs/Observable";
import { Http,Response  } from "@angular/http";

@Injectable()
export class StoreService {

  private store = new BehaviorSubject<number>(null);
  storeObservable = this.store.asObservable();

  private storeName = new BehaviorSubject<string>(null);
  storeNameObservable = this.storeName.asObservable();

  private isStoreEnabled = new BehaviorSubject<boolean>(true);
  storeEnabledObservable = this.isStoreEnabled.asObservable();

  private isGlobalReq = new BehaviorSubject<boolean>(true);
  isGlobalReqObservable = this.isGlobalReq.asObservable();

  private globalStoreID = new BehaviorSubject<number>(1);
  globalStoreObservable = this.globalStoreID.asObservable();

  private navigateToCatalog = new BehaviorSubject<boolean>(false);
  navigateToCatalogObservable = this.navigateToCatalog.asObservable();

  constructor(private _http: Http) {
  }

  changeStore(storeID: number) {
    this.store.next(storeID)
  }

  changeStoreName(storeName: string) {
    this.storeName.next(storeName)
  }

  changeIsStoreEnabled( isStoreEnabled : boolean){
    this.isStoreEnabled.next(isStoreEnabled);
  }

  changeIsGlobalReq( isGlobalReq : boolean){
    // this.isGlobalReq.next(isGlobalReq);
    this.isGlobalReq.next(true);
  }

  changeGlobalStoreID( globalStoreID: number){
    this.globalStoreID.next(globalStoreID);
  }

  changeNavigateToCatalog( isNavigateToCatalog: boolean){
    this.navigateToCatalog.next(isNavigateToCatalog);
  }

 /**
   * To handle the obervable error response
   * @param  {Response|any} error
   */
  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
  }

  getStoresLookup(includeGlobalStore: boolean, inActiveStores?: boolean) {
    let getStoresLookup = '';
    if (includeGlobalStore) {
      getStoresLookup = ApiUrlConstants.configurationApiUrl + '/stores/lookup?includeGlobalStore=' + includeGlobalStore;
    } else if (inActiveStores) {
      getStoresLookup = ApiUrlConstants.configurationApiUrl + '/stores/lookup?includeActiveStores=' + inActiveStores;
    } else {
      getStoresLookup = ApiUrlConstants.configurationApiUrl + '/stores/lookup';
    }
    return this._http
      .get(getStoresLookup)
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/store.service.ts